<template>
  <div class="page page__list">
    <search-bar
      @search="onSearch"
      name="cr_code,cr_custname,product.pr_detail "
      placeholder="输入单号、客户名称、产品名称进行查找"
      ref="searchBar"
    />
    <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
    <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
      <router-link
        class="weui-cell weui-cell_access"
        v-for="item in items"
        :key="item.cr_id"
        :to="'/stock/customer_receive/'+item.cr_id"
      >
        <div class="weui-cell__bd">
          <p>{{item.cr_custname}}</p>
          <p class="list-item-muted">{{item.cr_code}}</p>
        </div>
        <div class="weui-cell__ft">
          <p v-format="'yyyy-MM-dd'">{{item.cr_date}}</p>
          <span
            class="list-item-status"
            :class="{'warning':item.cr_status!='已审核'}"
          >{{item.cr_status}}</span>
        </div>
      </router-link>
    </scroll-list>
    <div class="list-footer">
      <label class="list-footer__label">合计：{{items.length}}单</label>
    </div>
    <!-- <add-button to="/stock/othin_edit" /> -->
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
// import AddButton from "@/components/button/Add.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    FilterBar,
    ScrollList,
    // AddButton
  },
  mixins: [list],
  data() {
    return {
      listUrl: "/api/storage/customerReceive/list",
      filters: [
        {
          type: "date",
          name: "cr_date"
        },
        {
          type: "condition",
          label: "状态",
          value: -1,
          options: [
            {
              value: -1,
              label: "全部",
              condition: ""
            },
            {
              value: 1,
              label: "待收料",
              condition: "cr_status_code<>'AUDITED'"
            },
            {
              value: 2,
              label: "已收料",
              condition: "cr_status_code='AUDITED'"
            }
          ]
        }
      ]
    };
  }
};
</script>